module.exports = __webpack_public_path__ + "img/exclamation-mark-icon.5ecf7fab.svg";